import { render, staticRenderFns } from "./ReportRegister.vue?vue&type=template&id=12b7c332&scoped=true"
import script from "./ReportRegister.vue?vue&type=script&lang=js"
export * from "./ReportRegister.vue?vue&type=script&lang=js"
import style0 from "./ReportRegister.vue?vue&type=style&index=0&id=12b7c332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7c332",
  null
  
)

export default component.exports